import React from 'react';
import '../styles/Testimonials.css';

const testimonials = [
  {
    id: 1,
    name: 'Ayesha Khan',
    route: 'Heathrow Transfer',
    review:
      'Very punctual and polite driver. The car was clean and comfortable, and the whole airport journey was stress-free.'
  },
  {
    id: 2,
    name: 'Daniel Roberts',
    route: 'City-to-City Trip',
    review:
      'Excellent service from booking to drop-off. Communication was clear, pricing was fair, and the trip was very smooth.'
  },
  {
    id: 3,
    name: 'Fatima Ali',
    route: 'Family Booking',
    review:
      'We requested a child seat and everything was arranged perfectly. Professional team and highly reliable taxi service.'
  }
];

const Testimonials = () => {
  return (
    <section id="testimonials" className="testimonials">
      <div className="testimonials-container">
        <h2 className="testimonials-title">What Our Customers Say</h2>
        <p className="testimonials-subtitle">
          Trusted by families, professionals, and travelers across the UK.
        </p>

        <div className="testimonials-grid">
          {testimonials.map((item) => (
            <article key={item.id} className="testimonial-card">
              <div className="testimonial-stars" aria-label="5 star rating">★★★★★</div>
              <p className="testimonial-review">"{item.review}"</p>
              <h3 className="testimonial-name">{item.name}</h3>
              <p className="testimonial-route">{item.route}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
